import { createSlice } from '@reduxjs/toolkit';
import userService from '../../utils/userService';

// Données mockées des professionnels
const mockProfessionals = [
  {
    id: 1,
    firstName: 'Marie',
    lastName: 'Dubois',
    fullName: 'Marie Dubois',
    email: 'marie.dubois@email.com',
    phone: '+33 6 12 34 56 78',
    profileImage: '/default-avatar.svg',
    discipline: 'Tennis',
    freelanceType: 'encadrement',
    specialties: ['Coaching technique', 'Préparation mentale', 'Entraînement jeunes'],
    location: 'Paris 16ème',
    coordinates: { lat: 48.8647, lng: 2.2736 },
    hourlyRate: 45,
    currency: '€',
    rating: 4.8,
    reviewsCount: 127,
    experience: 8,
    certifications: ['BPJEPS Tennis', 'Certificat FFT Niveau 2', 'Formation Préparation Mentale'],
    biography: 'Passionnée de tennis depuis mon plus jeune âge, j\'ai évolué en compétition nationale avant de me tourner vers l\'enseignement. Mon approche combine technique rigoureuse et développement de la confiance en soi.',
    availability: {
      monday: { available: true, slots: ['09:00-12:00', '14:00-18:00'] },
      tuesday: { available: true, slots: ['09:00-12:00', '14:00-18:00'] },
      wednesday: { available: false, slots: [] },
      thursday: { available: true, slots: ['09:00-12:00', '14:00-18:00'] },
      friday: { available: true, slots: ['09:00-12:00', '14:00-18:00'] },
      saturday: { available: true, slots: ['09:00-17:00'] },
      sunday: { available: false, slots: [] }
    },
    languages: ['Français', 'Anglais'],
    isVerified: true,
    joinedDate: '2022-03-15',
    completedMissions: 89,
    responseTime: '2h',
    reviews: [
      {
        id: 1,
        clientName: 'Sophie M.',
        rating: 5,
        comment: 'Excellente coach ! Ma fille a énormément progressé grâce à ses conseils.',
        date: '2024-01-15'
      },
      {
        id: 2,
        clientName: 'Pierre L.',
        rating: 5,
        comment: 'Très professionnelle et pédagogue. Je recommande vivement.',
        date: '2024-01-10'
      }
    ]
  },
  {
    id: 2,
    firstName: 'Thomas',
    lastName: 'Martin',
    fullName: 'Thomas Martin',
    email: 'thomas.martin@email.com',
    phone: '+33 6 23 45 67 89',
    profileImage: '/default-avatar.svg',
    discipline: 'Kinésithérapie',
    freelanceType: 'sante-bien-etre',
    specialties: ['Traumatologie sportive', 'Rééducation', 'Prévention blessures'],
    location: 'Lyon 3ème',
    coordinates: { lat: 45.7578, lng: 4.8320 },
    hourlyRate: 60,
    currency: '€',
    rating: 4.9,
    reviewsCount: 203,
    experience: 12,
    certifications: ['DE Kinésithérapeute', 'DU Traumatologie Sportive', 'Formation Dry Needling'],
    biography: 'Kinésithérapeute spécialisé dans le sport depuis plus de 10 ans. J\'accompagne les athlètes de tous niveaux dans leur récupération et leur préparation physique.',
    availability: {
      monday: { available: true, slots: ['08:00-12:00', '14:00-19:00'] },
      tuesday: { available: true, slots: ['08:00-12:00', '14:00-19:00'] },
      wednesday: { available: true, slots: ['08:00-12:00', '14:00-19:00'] },
      thursday: { available: true, slots: ['08:00-12:00', '14:00-19:00'] },
      friday: { available: true, slots: ['08:00-12:00', '14:00-17:00'] },
      saturday: { available: true, slots: ['09:00-13:00'] },
      sunday: { available: false, slots: [] }
    },
    languages: ['Français', 'Anglais', 'Italien'],
    isVerified: true,
    joinedDate: '2021-09-20',
    completedMissions: 156,
    responseTime: '1h',
    reviews: [
      {
        id: 1,
        clientName: 'Julie R.',
        rating: 5,
        comment: 'Excellent professionnel ! M\'a aidée à récupérer rapidement de ma blessure.',
        date: '2024-01-20'
      }
    ]
  },
  {
    id: 3,
    firstName: 'Sarah',
    lastName: 'Leroy',
    fullName: 'Sarah Leroy',
    email: 'sarah.leroy@email.com',
    phone: '+33 6 34 56 78 90',
    profileImage: '/default-avatar.svg',
    discipline: 'Basketball',
    freelanceType: 'encadrement',
    specialties: ['Arbitrage', 'Formation arbitres', 'Gestion de match'],
    location: 'Marseille',
    coordinates: { lat: 43.2965, lng: 5.3698 },
    hourlyRate: 80,
    currency: '€',
    rating: 4.6,
    reviewsCount: 89,
    experience: 6,
    certifications: ['Arbitre Fédéral Niveau 2', 'Formation Arbitrage FIBA', 'Certificat Gestion Conflits'],
    biography: 'Arbitre passionnée avec une excellente connaissance des règles. Je privilégie la communication et le fair-play pour des matchs de qualité.',
    availability: {
      monday: { available: false, slots: [] },
      tuesday: { available: true, slots: ['18:00-22:00'] },
      wednesday: { available: true, slots: ['18:00-22:00'] },
      thursday: { available: true, slots: ['18:00-22:00'] },
      friday: { available: true, slots: ['18:00-22:00'] },
      saturday: { available: true, slots: ['09:00-22:00'] },
      sunday: { available: true, slots: ['09:00-22:00'] }
    },
    languages: ['Français', 'Anglais'],
    isVerified: true,
    joinedDate: '2022-11-10',
    completedMissions: 67,
    responseTime: '3h',
    reviews: [
      {
        id: 1,
        clientName: 'Club Marseille Basket',
        rating: 5,
        comment: 'Arbitrage de qualité, très professionnelle.',
        date: '2024-01-18'
      }
    ]
  }
];

// Données pour générer plus de professionnels
const disciplines = [
  'Tennis', 'Football', 'Basketball', 'Natation', 'Athlétisme', 'Volleyball', 
  'Handball', 'Rugby', 'Kinésithérapie', 'Préparation physique', 'Yoga', 'Pilates'
];

const locations = [
  'Paris', 'Lyon', 'Marseille', 'Toulouse', 'Nice', 'Nantes', 'Strasbourg', 'Montpellier',
  'Bordeaux', 'Lille', 'Rennes', 'Reims', 'Cannes', 'Saint-Tropez', 'Chamonix', 'Biarritz',
  'Annecy', 'Avignon', 'Paris 16ème', 'Lyon 3ème'
];

const firstNames = {
  male: ['Thomas', 'Pierre', 'Nicolas', 'Julien', 'Alexandre', 'Maxime', 'Antoine', 'Sébastien', 'David', 'Christophe'],
  female: ['Marie', 'Sarah', 'Julie', 'Sophie', 'Emma', 'Camille', 'Laura', 'Manon', 'Léa', 'Chloé']
};

const lastNames = ['Martin', 'Dubois', 'Leroy', 'Moreau', 'Simon', 'Laurent', 'Lefebvre', 'Michel', 'Garcia', 'David', 'Bertrand', 'Roux', 'Vincent', 'Fournier', 'Morel'];

const profileImages = {
  male: [
    '/default-avatar.svg',
    '/default-avatar.svg',
    '/default-avatar.svg',
    '/default-avatar.svg',
    '/default-avatar.svg'
  ],
  female: [
    '/default-avatar.svg',
    '/default-avatar.svg',
    '/default-avatar.svg',
    '/default-avatar.svg',
    '/default-avatar.svg'
  ]
};

const specialtiesByDiscipline = {
  'Tennis': ['Coaching technique', 'Préparation mentale', 'Entraînement jeunes', 'Compétition'],
  'Football': ['Entraînement équipe', 'Technique individuelle', 'Préparation physique', 'Gardien de but'],
  'Basketball': ['Arbitrage', 'Coaching équipe', 'Technique de tir', 'Défense'],
  'Natation': ['Technique nage', 'Préparation compétition', 'Aquafitness', 'Sauvetage'],
  'Kinésithérapie': ['Traumatologie sportive', 'Rééducation', 'Prévention blessures', 'Massage sportif'],
  'Athlétisme': ['Sprint', 'Endurance', 'Saut', 'Lancer'],
  'Volleyball': ['Technique service', 'Coaching équipe', 'Préparation physique', 'Arbitrage'],
  'Handball': ['Coaching équipe', 'Technique tir', 'Défense', 'Gardien'],
  'Rugby': ['Mêlée', 'Technique plaquage', 'Coaching équipe', 'Préparation physique'],
  'Préparation physique': ['Musculation', 'Cardio', 'Récupération', 'Nutrition'],
  'Yoga': ['Hatha Yoga', 'Vinyasa', 'Yoga thérapeutique', 'Méditation'],
  'Pilates': ['Pilates classique', 'Pilates machine', 'Rééducation', 'Renforcement']
};

// Coordonnées des villes
const cityCoordinates = {
  'Paris': { lat: 48.8566, lng: 2.3522 },
  'Lyon': { lat: 45.7640, lng: 4.8357 },
  'Marseille': { lat: 43.2965, lng: 5.3698 },
  'Toulouse': { lat: 43.6047, lng: 1.4442 },
  'Nice': { lat: 43.7102, lng: 7.2620 },
  'Nantes': { lat: 47.2184, lng: -1.5536 },
  'Strasbourg': { lat: 48.5734, lng: 7.7521 },
  'Montpellier': { lat: 43.6110, lng: 3.8767 },
  'Bordeaux': { lat: 44.8378, lng: -0.5792 },
  'Lille': { lat: 50.6292, lng: 3.0573 },
  'Rennes': { lat: 48.1173, lng: -1.6778 },
  'Reims': { lat: 49.2583, lng: 4.0317 },
  'Paris 16ème': { lat: 48.8647, lng: 2.2736 },
  'Lyon 3ème': { lat: 45.7578, lng: 4.8320 },
  'Cannes': { lat: 43.5528, lng: 7.0174 },
  'Saint-Tropez': { lat: 43.2677, lng: 6.6407 },
  'Chamonix': { lat: 45.9237, lng: 6.8694 },
  'Biarritz': { lat: 43.4832, lng: -1.5586 },
  'Annecy': { lat: 45.8992, lng: 6.1294 },
  'Avignon': { lat: 43.9493, lng: 4.8059 }
};

// Mapping des disciplines vers les types de freelance
const disciplineToFreelanceType = {
  'Tennis': 'encadrement',
  'Football': 'encadrement',
  'Basketball': 'encadrement',
  'Natation': 'encadrement',
  'Athlétisme': 'encadrement',
  'Volleyball': 'encadrement',
  'Handball': 'encadrement',
  'Rugby': 'encadrement',
  'Kinésithérapie': 'sante-bien-etre',
  'Préparation physique': 'sante-bien-etre',
  'Yoga': 'sante-bien-etre',
  'Pilates': 'sante-bien-etre'
};

// Générer plus de professionnels
for (let i = 4; i <= 50; i++) {
  const gender = Math.random() > 0.5 ? 'male' : 'female';
  const firstName = firstNames[gender][Math.floor(Math.random() * firstNames[gender].length)];
  const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
  const discipline = disciplines[Math.floor(Math.random() * disciplines.length)];
  const location = locations[Math.floor(Math.random() * locations.length)];
  const coordinates = cityCoordinates[location] || { lat: 46.6034, lng: 1.8883 };
  
  // Assigner le type de freelance selon la discipline, avec possibilité d'événementiel et marketing
  let freelanceType = disciplineToFreelanceType[discipline] || 'encadrement';
  const randomType = Math.random();
  if (randomType < 0.1) {
    freelanceType = 'evenementiel';
  } else if (randomType < 0.15) {
    freelanceType = 'marketing';
  }
  
  mockProfessionals.push({
    id: i,
    firstName,
    lastName,
    fullName: `${firstName} ${lastName}`,
    email: `${firstName.toLowerCase()}.${lastName.toLowerCase()}@email.com`,
    phone: `+33 6 ${Math.floor(Math.random() * 90 + 10)} ${Math.floor(Math.random() * 90 + 10)} ${Math.floor(Math.random() * 90 + 10)} ${Math.floor(Math.random() * 90 + 10)}`,
    profileImage: profileImages[gender][Math.floor(Math.random() * profileImages[gender].length)],
    discipline,
    freelanceType,
    specialties: specialtiesByDiscipline[discipline] ? 
      specialtiesByDiscipline[discipline].slice(0, Math.floor(Math.random() * 3) + 2) : 
      ['Coaching', 'Formation'],
    location,
    coordinates,
    hourlyRate: Math.floor(Math.random() * 80) + 30,
    currency: '€',
    rating: Math.round((Math.random() * 1.5 + 3.5) * 10) / 10,
    reviewsCount: Math.floor(Math.random() * 200) + 10,
    experience: Math.floor(Math.random() * 15) + 1,
    certifications: [`Certification ${discipline}`, 'Formation professionnelle'],
    biography: `Professionnel passionné de ${discipline.toLowerCase()} avec ${Math.floor(Math.random() * 15) + 1} ans d'expérience. Je m'engage à offrir un service de qualité adapté aux besoins de chaque client.`,
    availability: {
      monday: { available: Math.random() > 0.3, slots: ['09:00-12:00', '14:00-18:00'] },
      tuesday: { available: Math.random() > 0.2, slots: ['09:00-12:00', '14:00-18:00'] },
      wednesday: { available: Math.random() > 0.2, slots: ['09:00-12:00', '14:00-18:00'] },
      thursday: { available: Math.random() > 0.2, slots: ['09:00-12:00', '14:00-18:00'] },
      friday: { available: Math.random() > 0.2, slots: ['09:00-12:00', '14:00-18:00'] },
      saturday: { available: Math.random() > 0.4, slots: ['09:00-17:00'] },
      sunday: { available: Math.random() > 0.7, slots: ['10:00-16:00'] }
    },
    languages: ['Français'],
    isVerified: Math.random() > 0.2,
    joinedDate: `202${Math.floor(Math.random() * 4) + 1}-${String(Math.floor(Math.random() * 12) + 1).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')}`,
    completedMissions: Math.floor(Math.random() * 150) + 5,
    responseTime: `${Math.floor(Math.random() * 12) + 1}h`,
    reviews: [
      {
        id: 1,
        clientName: 'Client satisfait',
        rating: Math.floor(Math.random() * 2) + 4,
        comment: 'Très bon professionnel, je recommande !',
        date: '2024-01-15'
      }
    ]
  });
}

const initialState = {
  professionals: mockProfessionals,
  favorites: [],
  loading: false,
  error: null,
  filters: {
    search: '',
    discipline: '',
    freelanceType: '',
    location: '',
    rateMin: 0,
    rateMax: 200,
    ratingMin: 0,
    availability: '',
    distance: 50,
    isVerified: false
  },
  currentPage: 1,
  itemsPerPage: 12,
  totalPages: 1,
  sortBy: 'rating',
  selectedProfessional: null
};

const professionalsSlice = createSlice({
  name: 'professionals',
  initialState,
  reducers: {
    setProfessionals: (state, action) => {
      const raw = action.payload?.data || action.payload || [];
      state.professionals = Array.isArray(raw) ? raw.map(transformProfessional) : [];
    },
    selectProfessional: (state, action) => {
      state.selectedProfessional = action.payload;
    },
    applyFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
      state.currentPage = 1;
    },
    clearFilters: (state) => {
      state.filters = {
        search: '',
        discipline: '',
        freelanceType: '',
        location: '',
        rateMin: 0,
        rateMax: 200,
        ratingMin: 0,
        availability: '',
        distance: 50,
        isVerified: false
      };
      state.currentPage = 1;
    },
    toggleFavorite: (state, action) => {
      const idStr = String(action.payload);
      const index = state.favorites.findIndex(f => String(f) === idStr);
      if (index > -1) {
        state.favorites.splice(index, 1);
      } else {
        state.favorites.push(idStr);
      }
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
    },
    setSortBy: (state, action) => {
      state.sortBy = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  }
});

// Transformer un utilisateur backend vers la forme attendue par l'UI
const transformProfessional = (user) => {
  if (!user) return user;
  const id = user._id || user.id;
  const firstName = user.firstName || '';
  const lastName = user.lastName || '';
  const fullName = user.fullName || `${firstName} ${lastName}`.trim();
  const email = user.email;
  const phone = user.phone;
  let profileImage;
  if (user && user.avatar) {
    if (typeof user.avatar === 'object') {
      profileImage = user.avatar.url || user.avatar.secure_url || user.avatar.path || '/default-avatar.svg';
    } else {
      profileImage = user.avatar;
    }
  } else {
    profileImage = user.profileImage || '/default-avatar.svg';
  }
  const location = user.address?.city || user.location || '';
  const coordinates = user.address?.coordinates || user.coordinates;
  const professional = user.professional || {};
  const hourlyRate = professional.hourlyRate ?? user.hourlyRate ?? 0;
  const currency = '€';
  const rating = professional.rating?.average ?? user.rating ?? 0;
  const reviewsCount = professional.rating?.count ?? user.totalReviews ?? 0;
  const experience = professional.experience ?? user.experience ?? 0;
  const specialties = Array.isArray(professional.specialties) ? professional.specialties : (user.specialties || []);
  const discipline = user.discipline || specialties?.[0] || 'Sport';
  const availability = professional.availability || user.availability || {
    monday: { available: true, slots: [] },
    tuesday: { available: true, slots: [] },
    wednesday: { available: true, slots: [] },
    thursday: { available: true, slots: [] },
    friday: { available: true, slots: [] },
    saturday: { available: true, slots: [] },
    sunday: { available: false, slots: [] }
  };
  const languages = user.languages || ['Français'];
  const isVerified = !!user.isVerified;
  const joinedDate = user.joinDate || user.joinedDate;
  const completedMissions = user.stats?.missionsCompleted ?? user.completedMissions ?? 0;
  const responseTime = user.stats?.responseTime || user.responseTime || '—';
  const reviews = user.reviews || [];
  const certifications = user.certifications || [];
  const freelanceType = user.freelanceType || (['Kinésithérapie','Préparation physique','Yoga','Pilates'].includes(discipline) ? 'sante-bien-etre' : 'encadrement');

  return {
    id,
    firstName,
    lastName,
    fullName,
    email,
    phone,
    profileImage,
    discipline,
    freelanceType,
    specialties,
    location,
    coordinates,
    hourlyRate,
    currency,
    rating,
    reviewsCount,
    experience,
    certifications,
    biography: user.bio || user.biography,
    availability,
    languages,
    isVerified,
    joinedDate,
    completedMissions,
    responseTime,
    reviews
  };
};

// Action asynchrone pour récupérer les professionnels depuis l'API
export const fetchProfessionals = (params = {}) => async (dispatch, getState) => {
  dispatch(setLoading(true));
  try {
    const state = getState();
    const { filters, sortBy, itemsPerPage } = state.professionals;

    // Construire les paramètres en respectant le backend et l'UI actuelle
    const query = {};

    // Recherche texte (prénom/nom/email côté backend)
    if (filters.search) query.search = filters.search;

    // Localisation simple par ville
    if (filters.location) query['address.city'] = filters.location;

    // Tarif horaire (plage)
    if (typeof filters.rateMin === 'number') query['professional.hourlyRate[gte]'] = filters.rateMin;
    if (typeof filters.rateMax === 'number' && filters.rateMax > 0) query['professional.hourlyRate[lte]'] = filters.rateMax;

    // Note minimale
    if (typeof filters.ratingMin === 'number' && filters.ratingMin > 0) {
      query['professional.rating.average[gte]'] = filters.ratingMin;
    }

    // Discipline et type de freelance
    if (filters.discipline) {
      // Filtre exact sur la discipline si supporté côté backend
      query['professional.disciplines'] = filters.discipline;
    }
    if (filters.freelanceType) {
      query['professional.freelanceType'] = filters.freelanceType;
    }

    // Vérification
    if (filters.isVerified) query.isVerified = true;

    // Tri
    if (sortBy === 'rating') query.sort = '-professional.rating.average';
    else if (sortBy === 'price_asc') query.sort = 'professional.hourlyRate';
    else if (sortBy === 'price_desc') query.sort = '-professional.hourlyRate';
    else if (sortBy === 'experience') query.sort = '-professional.experience';
    else if (sortBy === 'name') query.sort = 'firstName';

    // Rôle professionnel uniquement
    query.role = 'professional';

    // Taille de page élevée pour conserver la pagination côté client sans casser l'UI
    query.limit = Math.max(itemsPerPage * 5, 60);

    const response = await userService.getProfessionals({ ...query, ...params });
    // userService renvoie généralement { data, pagination, total }
    dispatch(setProfessionals(response));
  } catch (error) {
    const status = error?.response?.status;
    dispatch(setProfessionals(mockProfessionals));
    if (status === 401 || status === 403) {
      dispatch(setError(null));
    } else {
      const message = error?.message || 'Erreur lors du chargement des professionnels. Affichage des données locales.';
      dispatch(setError(message));
    }
  } finally {
    dispatch(setLoading(false));
  }
};

// Sélecteurs
export const selectProfessionalById = (state, professionalId) => {
  const idStr = String(professionalId);
  return state.professionals.professionals.find(professional => String(professional.id) === idStr);
};

export const selectFilteredProfessionals = (state) => {
  const { professionals, filters, sortBy, currentPage, itemsPerPage } = state.professionals;
  let filtered = [...professionals];

  // Filtrage par recherche
  if (filters.search) {
    const searchLower = filters.search.toLowerCase();
    filtered = filtered.filter(professional => 
      professional.fullName.toLowerCase().includes(searchLower) ||
      professional.discipline.toLowerCase().includes(searchLower) ||
      professional.location.toLowerCase().includes(searchLower) ||
      professional.specialties.some(specialty => specialty.toLowerCase().includes(searchLower))
    );
  }

  // Filtrage par discipline
  if (filters.discipline) {
    filtered = filtered.filter(professional => professional.discipline === filters.discipline);
  }

  // Filtrage par type de freelance
  if (filters.freelanceType) {
    filtered = filtered.filter(professional => professional.freelanceType === filters.freelanceType);
  }

  // Filtrage par localisation
  if (filters.location) {
    filtered = filtered.filter(professional => professional.location.includes(filters.location));
  }

  // Filtrage par tarif
  if (filters.rateMin > 0 || filters.rateMax < 200) {
    filtered = filtered.filter(professional => 
      professional.hourlyRate >= filters.rateMin && professional.hourlyRate <= filters.rateMax
    );
  }

  // Filtrage par note
  if (filters.ratingMin > 0) {
    filtered = filtered.filter(professional => professional.rating >= filters.ratingMin);
  }

  // Filtrage par vérification
  if (filters.isVerified) {
    filtered = filtered.filter(professional => professional.isVerified);
  }

  // Tri
  switch (sortBy) {
    case 'rating':
      filtered.sort((a, b) => b.rating - a.rating);
      break;
    case 'price_asc':
      filtered.sort((a, b) => a.hourlyRate - b.hourlyRate);
      break;
    case 'price_desc':
      filtered.sort((a, b) => b.hourlyRate - a.hourlyRate);
      break;
    case 'experience':
      filtered.sort((a, b) => b.experience - a.experience);
      break;
    case 'name':
      filtered.sort((a, b) => a.fullName.localeCompare(b.fullName));
      break;
    default:
      // Tri par pertinence (rating + nombre de missions)
      filtered.sort((a, b) => (b.rating * b.completedMissions) - (a.rating * a.completedMissions));
  }

  // Calcul de la pagination
  const totalPages = Math.ceil(filtered.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedProfessionals = filtered.slice(startIndex, endIndex);

  return {
    filteredProfessionals: filtered,
    paginatedProfessionals,
    totalPages,
    currentPage,
    itemsPerPage,
    totalCount: filtered.length
  };
};

export const selectFavoriteProfessionals = (state) => {
  const { professionals, favorites } = state.professionals;
  const favSet = new Set(favorites.map(f => String(f)));
  return professionals.filter(professional => favSet.has(String(professional.id)));
};

export const {
  setProfessionals,
  selectProfessional,
  applyFilters,
  clearFilters,
  toggleFavorite,
  setCurrentPage,
  setItemsPerPage,
  setSortBy,
  setLoading,
  setError
} = professionalsSlice.actions;

export default professionalsSlice.reducer;